import indigo from "@material-ui/core/colors/indigo";
import pink from "@material-ui/core/colors/pink";
import green from "@material-ui/core/colors/green";

export default {
  palette: {
    primary: {
      light: green[300],
      main: green[500],
      dark: green[700],
      contrastText: "#fff",
    },
    secondary: {
      light: pink[300],
      main: pink["A200"],
      dark: pink[700],
      contrastText: "#fff",
    },
  },
  status: {
    danger: "orange",
  },
  typography: {
    button: {
      fontWeight: 400,
      textAlign: "capitalize",
    },
  },
};
